import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default ({ palette }: Theme) =>
  createStyles({
    autocomplete: {
      width: '100%',
    },
    chip: {
      margin: 4,
      background: 'transparent',
      border: `1px solid ${palette.primary.main}`,
    },
    deleteIcon: {
      width: 18,
      height: 18,
      color: palette.grey[600],
    },
    error: {
      color: palette.error.main,
      padding: '0 12px',
      margin: '8px 14px 0',
    },
  });
